import { INewbuildingBrokerCallbackWidget } from 'shared/types/newbuildingBrokerCallbackWidget';

export const getNewbuildingBrokerProducts = (offerInfo: INewbuildingBrokerCallbackWidget['offerInfo']) => {
  return [
    {
      id: offerInfo?.offer.id,
      offerType: 'offer',
      position: offerInfo?.position,
    },
  ];
};

export const getNewbuildingBrokerGaLabel = (offerInfo: INewbuildingBrokerCallbackWidget['offerInfo']) => {
  return offerInfo?.offer.gaLabel ?? /* istanbul ignore next */ '';
};
